// import axios from './../../containers/PlaylistPod/axios-playlist';
import {
  ActionsObservable,
  combineEpics,
  StateObservable
} from 'redux-observable';
import { from, of, timer } from 'rxjs';
import {
  catchError,
  mergeMap,
  startWith,
  switchMap,
  takeUntil
} from 'rxjs/operators';
import { IState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import {
  restoreFilters,
  setMissingAssetsFilters,
  setPlaylistFilters,
  setPlaylistFiltersFirstTime
} from '../actions/filterActions';
import {
  fetchPlaylists,
  fetchPlaylistsPending,
  fetchPlaylistsSuccess,
  IEscalatePlaylist,
  IFetchPlaylists,
  IResolvePlaylist,
  ISelectPlaylist,
  ISnoozePlaylist
} from '../actions/playlistActions';

import axios from '../../axios-pod';

export const onLoadPlaylists = (
  action$: ActionsObservable<IFetchPlaylists>,
  state$: StateObservable<IState>
) =>
  action$.ofType(actionTypes.FETCH_PLAYLISTS).pipe(
    switchMap((action: IFetchPlaylists) => {
      let resetFilters = action.resetFilters ? action.resetFilters : false;
      const state = state$.value; // extract the states
      return timer(
        0,
        globalThis.UI_CONFIG ? globalThis.UI_CONFIG.playlist_poll_time : 180000
      ).pipe(
        // timer every n minutes
        // destroy the polling
        takeUntil(action$.ofType(actionTypes.FETCH_PLAYLISTS_REJECT)),
        switchMap(_ => {
          const customers = [];
          let feeds = [];
          const screens = state.screens;
          screens.screenMap[screens.selectedScreen].customers.map(customer => {
            customers.push(customer.name);
            feeds = feeds.concat(customer.channels);
          });
          return from(
            axios.get(`playlists`, {
              params: {
                userId: state.user.userInfo.userId,
                customers: customers.join(','),
                feeds: feeds.join(',')
              }
            })
          ).pipe(
            mergeMap(response => {
              const resultArray: any = [
                fetchPlaylistsSuccess(response.data.result)
              ];
              if (resetFilters) {
                resultArray.push(
                  setPlaylistFiltersFirstTime(response.data.result) // todo: change to set filters first time
                );
                const oldSelectedScreen = localStorage.getItem(
                  'podSelectedScreen'
                );
                // if the selected screen exist and
                if (
                  oldSelectedScreen &&
                  state.screens.selectedScreen &&
                  oldSelectedScreen === state.screens.selectedScreen
                ) {
                  resultArray.push(restoreFilters());
                }
                resetFilters = false; // since in the timer loop it will always call setFiltersFirstTimer.
              } else {
                resultArray.push(setPlaylistFilters(response.data.result));
              }
              return resultArray;
            }),
            catchError(e => of()), // todo: change this to snackbar error action
            startWith(fetchPlaylistsPending())
          );
        })
      );
    })
  );

export const onEscalatePlaylist = (
  action$: ActionsObservable<IEscalatePlaylist>
) =>
  action$.ofType(actionTypes.ESCALATE_PLAYLIST).pipe(
    switchMap((action: IEscalatePlaylist) => {
      return from(axios.post('playlist/escalate', action.payload)).pipe(
        mergeMap((response: any) => {
          return [fetchPlaylists(false)];
        }),
        catchError(_ => of())
      );
    })
  );

export const onSelectPlaylist = (action$: ActionsObservable<ISelectPlaylist>) =>
  action$.ofType(actionTypes.SELECT_PLAYLIST).pipe(
    switchMap((action: ISelectPlaylist) => {
      return [setMissingAssetsFilters({ playlistId: action.playlistId })];
    })
  );

export const onSnoozePlaylist = (action$: ActionsObservable<ISnoozePlaylist>) =>
  action$.ofType(actionTypes.SNOOZE_PLAYLIST).pipe(
    switchMap((action: ISnoozePlaylist) => {
      return from(axios.post('playlist/snooze', action.payload)).pipe(
        mergeMap((response: any) => {
          return [fetchPlaylists(false)];
        }),
        catchError(_ => of())
      );
    })
  );

export const onResolvePlaylist = (
  action$: ActionsObservable<IResolvePlaylist>
) =>
  action$.ofType(actionTypes.RESOLVE_PLAYLIST).pipe(
    switchMap((action: IResolvePlaylist) => {
      return from(axios.post('playlist/resolve', action.payload)).pipe(
        mergeMap((response: any) => {
          return [fetchPlaylists(false)];
        }),
        catchError(_ => of())
      );
    })
  );

export default combineEpics(
  onLoadPlaylists,
  onEscalatePlaylist,
  onSelectPlaylist,
  onSnoozePlaylist,
  onResolvePlaylist
);
